import { SelectProps } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

import Input from '../../../../components/Input';
import MultiSelect from '../../../../components/MultiSelect';
import Select from '../../../../components/Select';
import Toggle from '../../../../components/Toggle';

type FormProps = {
  additiveOptions: SelectProps.Option[];
  allergenOptions: SelectProps.Option[];
};
export const dayOptions = [
  {
    value: '1',
    label: 'Montag',
  },
  {
    value: '2',
    label: 'Dienstag',
  },
  {
    value: '3',
    label: 'Mittwoch',
  },
  {
    value: '4',
    label: 'Donnerstag',
  },
  {
    value: '5',
    label: 'Freitag',
  },
];

export default function Form({ additiveOptions, allergenOptions }: FormProps) {
  return (
    <SpaceBetween size="m">
      <Input name="title" label="Titel" stretch />
      <Input name="subtitle" label="Untertitel" stretch />
      <Input name="price" label="Preis in Euro" stretch />
      <Select name="displayday" label="Tag" options={dayOptions} stretch />
      <Select
        name="foodtype"
        label="Typ"
        options={[
          {
            value: 'meat',
            label: 'Enthält Fleisch',
          },
          {
            value: 'vegan',
            label: 'Vegan',
          },
          {
            value: 'vegetarian',
            label: 'Vegetarisch',
          },
        ]}
        stretch
      />
      <MultiSelect
        name="productinformation"
        label="Informationen zum Produkt"
        options={[
          {
            label: 'Allergene',
            options: allergenOptions,
          },
          {
            label: 'Zusatzstoffe',
            options: additiveOptions,
          },
        ]}
        stretch
      />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={true}
            label="Aktive"
            description="Kann dieser Eintrag angezeigt werden"
            name="is_active"
          />
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
